export default __webpack_public_path__ + "static/media/Blackfist.31ab6cb2.jpg";